import type { Organization } from '@/types/events';

export type EventJoinCtaTone = 'primary' | 'applied' | 'joined';

/** Label + disabled for event card Join / Applied! / Joined! using application + volunteer state */
export function getEventJoinCta(event: Organization): {
  label: string;
  disabled: boolean;
  tone: EventJoinCtaTone;
} {
  if (event.isAlreadyVolunteer) {
    return { label: 'Joined!', disabled: true, tone: 'joined' };
  }
  const st = event.userApplication?.status?.toLowerCase();
  if (st === 'pending') {
    return { label: 'Applied!', disabled: true, tone: 'applied' };
  }
  if (st === 'accepted') {
    return { label: 'Joined!', disabled: true, tone: 'joined' };
  }
  return { label: 'Join', disabled: false, tone: 'primary' };
}
